module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.isSuggestedAddressModalVisible) ? _c('address-suggestion') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-heading"
  }, [(_vm.accountType === 'institution') ? _c('div', [_vm._v("Create account / Institution account")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('div', [_vm._v("Create account / Trust account")]) : _vm._e(), _vm._v(" "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Go back")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.isLoading || _vm.userDetailLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-title"
  }, [(_vm.accountType === 'institution') ? _c('div', [_vm._v("Institution information")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('div', [_vm._v("Trust information")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [(_vm.accountType === 'institution') ? _c('label', [_vm._v("Institution name*")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('label', [_vm._v("Trust name*")]) : _vm._e()])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [(_vm.accountType === 'institution') ? _c('div', [_c('RestrictedSingleInput', {
    attrs: {
      "input": _vm.institutionName,
      "limit": 40,
      "placeholderText": 'Institution name'
    },
    on: {
      "inputUpdated": _vm.onInstitutionNameUpdate
    }
  }), _vm._v(" "), (_vm.institutionNameChanged && _vm.institutionName.trim().length === 0) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('div', [_c('RestrictedSingleInput', {
    attrs: {
      "input": _vm.trustName,
      "limit": 40,
      "placeholderText": 'Trust name'
    },
    on: {
      "inputUpdated": _vm.onTrustNameUpdate
    }
  }), _vm._v(" "), (_vm.trustNameChanged && _vm.trustName.trim().length === 0) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taxId),
      expression: "taxId"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: (_vm.accountType === 'institution' ? '99-9999999' : '999999999'),
      expression: "accountType === 'institution' ? '99-9999999' : '999999999'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('taxId') || _vm.isTaxIdInvalid(_vm.taxId)
    },
    attrs: {
      "name": "taxId",
      "id": "taxId",
      "type": "text",
      "placeholder": "Tax ID"
    },
    domProps: {
      "value": (_vm.taxId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.taxId = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('taxId') || _vm.isTaxIdInvalid(_vm.taxId)) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [(_vm.accountType === 'institution') ? _c('label', [_vm._v("Institution type*")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('label', [_vm._v("Trust type*")]) : _vm._e()])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [(_vm.accountType === 'institution') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.institutionTypeSelected),
      expression: "institutionTypeSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('institutionType')
    },
    attrs: {
      "name": "institutionType",
      "id": "institutionType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.institutionTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Institution type")]), _vm._v(" "), _vm._l((_vm.institutionTypes), function(institutionType, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": institutionType.name
      }
    }, [_vm._v(_vm._s(institutionType.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('institutionType')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trustTypeSelected),
      expression: "trustTypeSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('trustType')
    },
    attrs: {
      "name": "trustType",
      "id": "trustType",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.trustTypeSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Trust type")]), _vm._v(" "), _vm._l((_vm.trustTypes), function(trustType, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": trustType.name
      }
    }, [_vm._v(_vm._s(trustType.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('trustType')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(999) 999-9999'),
      expression: "'(999) 999-9999'"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('phoneNumber') || _vm.isPhoneNumberInvalid(_vm.phoneNumber)
    },
    attrs: {
      "name": "phoneNumber",
      "id": "phoneNumber",
      "type": "text",
      "placeholder": "Phone number"
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('phoneNumber') || _vm.isPhoneNumberInvalid(_vm.phoneNumber)) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), (_vm.accountType === 'institution') ? _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.adjacentEmails), function(email, index) {
    return (_vm.accountType === 'institution') ? _c('div', {
      key: index,
      staticClass: "row bottom-margin"
    }, [_c('div', {
      staticClass: "col-md-5"
    }, [_c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.adjacentEmails[index]),
        expression: "adjacentEmails[index]"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('email'),
        expression: "'email'"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true, 'form-control-error': _vm.errors.has('institutionEmail' + index)
      },
      attrs: {
        "name": 'institutionEmail' + index,
        "id": 'institutionEmail' + index,
        "type": "email",
        "placeholder": "Email"
      },
      domProps: {
        "value": (_vm.adjacentEmails[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.adjacentEmails, index, $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.errors.has('institutionEmail' + index)) ? _c('span', {
      staticClass: "error-feedback"
    }, [_vm._v("Invalid email format")]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5"
    }, [(index === 0) ? _c('button', {
      staticClass: "btn btn-info btn-md button-add-more",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.addEmailSubmit()
        }
      }
    }, [_vm._v("Add more")]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [(_vm.accountType === 'institution') ? _c('div', [_vm._v("Institution address")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('div', [_vm._v("Trust address")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('RestrictedTwoInputs', {
    attrs: {
      "instructionsLabel": "Make sure your address doesn't exceed 50 characters.",
      "id": "ResidentialAddress",
      "fieldLabel": "Street address*",
      "primaryPlaceholder": "Street and number e.g. 123 Any Street",
      "secondaryPlaceholder": "(optional) Building, floor, etc.",
      "dual": true,
      "primaryInput": _vm.residentialAddress.streetAddress1,
      "secondaryInput": _vm.residentialAddress.streetAddress2
    },
    on: {
      "inputUpdated": _vm.residentialAddressUpdated
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residentialAddress.zipCode),
      expression: "residentialAddress.zipCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('zipCode') || _vm.isZipCodeInvalid(_vm.residentialAddress.zipCode)
    },
    attrs: {
      "name": "zipCode",
      "id": "zipCode",
      "type": "text",
      "placeholder": "Zip code"
    },
    domProps: {
      "value": (_vm.residentialAddress.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.residentialAddress.zipCode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('zipCode') || _vm.isZipCodeInvalid(_vm.residentialAddress.zipCode)) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residentialAddress.city),
      expression: "residentialAddress.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('mainCity')
    },
    attrs: {
      "name": "mainCity",
      "id": "mainCity",
      "type": "text",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.residentialAddress.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.residentialAddress.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('mainCity')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residentialAddress.state),
      expression: "residentialAddress.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('state')
    },
    attrs: {
      "name": "state",
      "id": "state",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.residentialAddress.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _vm._l((_vm.countryStates('residentialAddress')), function(s, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": s.abbreviation
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('state')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.residentialAddress.country),
      expression: "residentialAddress.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('Country')
    },
    attrs: {
      "name": "Country",
      "id": "Country",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.residentialAddress.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _vm._l((_vm.geoLocation.countries), function(c, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": c.abbreviation
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('country')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hasDifferentMailingAddress),
      expression: "hasDifferentMailingAddress"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "hasDifferentMailingAddress"
    },
    domProps: {
      "checked": Array.isArray(_vm.hasDifferentMailingAddress) ? _vm._i(_vm.hasDifferentMailingAddress, "") > -1 : (_vm.hasDifferentMailingAddress)
    },
    on: {
      "click": function($event) {
        _vm.submitDifferentMailingAddress()
      },
      "__c": function($event) {
        var $$a = _vm.hasDifferentMailingAddress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.hasDifferentMailingAddress = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.hasDifferentMailingAddress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.hasDifferentMailingAddress = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v("Different mailing address\n                ")])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('RestrictedTwoInputs', {
    attrs: {
      "instructionsLabel": "Make sure your address doesn't exceed 50 characters.",
      "id": "MailingAddress",
      "fieldLabel": "Street address*",
      "primaryPlaceholder": "Street and number e.g. 123 Any Street",
      "secondaryPlaceholder": "(optional) Building, floor, etc.",
      "dual": true,
      "primaryInput": _vm.mailingAddress.streetAddress1,
      "secondaryInput": _vm.mailingAddress.streetAddress2,
      "isDisabled": !_vm.hasDifferentMailingAddress
    },
    on: {
      "inputUpdated": _vm.mailingAddressUpdated
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailingAddress.zipCode),
      expression: "mailingAddress.zipCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': (_vm.hasDifferentMailingAddress && _vm.errors.has('mailingZipCode')) || _vm.isZipCodeInvalid(_vm.mailingAddress.zipCode)
    },
    attrs: {
      "disabled": !_vm.hasDifferentMailingAddress,
      "name": "mailingZipCode",
      "id": "mailingZipCode",
      "type": "text",
      "placeholder": "Zip code"
    },
    domProps: {
      "value": (_vm.mailingAddress.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailingAddress.zipCode = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasDifferentMailingAddress && (_vm.errors.has('mailingZipCode') || _vm.isZipCodeInvalid(_vm.mailingAddress.zipCode))) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailingAddress.city),
      expression: "mailingAddress.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'form-control-error': _vm.hasDifferentMailingAddress && _vm.errors.has('mailingCity')
    },
    attrs: {
      "disabled": !_vm.hasDifferentMailingAddress,
      "name": "mailingCity",
      "id": "mailingCity",
      "type": "text",
      "placeholder": "City"
    },
    domProps: {
      "value": (_vm.mailingAddress.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailingAddress.city = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasDifferentMailingAddress && _vm.errors.has('mailingCity')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailingAddress.state),
      expression: "mailingAddress.state"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control ': true, 'form-control-error': _vm.hasDifferentMailingAddress && _vm.errors.has('mailingState'), 'disabled-state': !_vm.hasDifferentMailingAddress
    },
    attrs: {
      "disabled": !_vm.hasDifferentMailingAddress,
      "name": "mailingState",
      "id": "mailingState",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mailingAddress.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("State")]), _vm._v(" "), _vm._l((_vm.countryStates('mailingAddress')), function(s, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": s.abbreviation
      }
    }, [_vm._v(_vm._s(s.name))])
  })], 2), _vm._v(" "), (_vm.hasDifferentMailingAddress && _vm.errors.has('mailingState')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailingAddress.country),
      expression: "mailingAddress.country"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('Country'), 'disabled-state': !_vm.hasDifferentMailingAddress
    },
    attrs: {
      "disabled": !_vm.hasDifferentMailingAddress,
      "name": "Country",
      "id": "Country",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mailingAddress.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Country")]), _vm._v(" "), _vm._l((_vm.geoLocation.countries), function(c, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": c.abbreviation
      }
    }, [_vm._v(_vm._s(c.name))])
  })], 2), _vm._v(" "), (_vm.errors.has('country')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-title"
  }, [(_vm.accountType === 'institution') ? _c('div', [_vm._v("Documentation of authorized signers")]) : _vm._e(), _vm._v(" "), (_vm.accountType === 'trust') ? _c('div', [_vm._v("Trust document")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-container",
    class: {
      'has-error': _vm.isFileInvalid
    }
  }, [_c('div', {
    staticClass: "bottom-margin"
  }, [_c('input', {
    ref: "fileupload",
    staticClass: "form-control filestyle",
    staticStyle: {
      "position": "absolute",
      "clip": "rect(0px 0px 0px 0px)"
    },
    attrs: {
      "type": "file",
      "data-classbutton": "btn btn-default",
      "data-classinput": "form-control inline",
      "id": "filestyle-0",
      "tabindex": "-1",
      "accept": _vm.getAcceptedFileExtensions()
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bootstrap-filestyle input-group"
  }, [_c('input', {
    staticClass: "form-control ",
    attrs: {
      "type": "text",
      "placeholder": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.selectedFile ? _vm.selectedFile.name : ''
    }
  }), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v("Your file must be in JPG, JPEG, PNG, TIF or PDF format and cannot exceed 10MB.")]), _vm._v(" "), (_vm.isFileInvalid) ? _c('span', {
    staticClass: "help-block m-b-none"
  }, [_vm._v("The file you selected is not valid. Please select a different file.")]) : _vm._e()]), _vm._v(" "), (_vm.uploadedFiles.length > 0) ? _c('div', {
    staticClass: "space table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-files"
  }, [_vm._m(7), _vm._v(" "), _c('tbody', _vm._l((_vm.uploadedFiles), function(file, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(((_vm.user.firstName) + " " + (_vm.user.lastName))))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm.formatDate(new Date())))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      staticClass: "text-red",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeDocument(index)
        }
      }
    }, [_c('em', {
      staticClass: "fa fa-trash"
    })])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "space"
  })]) : _vm._e(), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "line-separator"
  }), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.principalPaymentSelected),
      expression: "principalPaymentSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('principalPayment')
    },
    attrs: {
      "name": "principalPayment",
      "id": "principalPayment",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.principalPaymentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select principal payment preference")]), _vm._v(" "), _vm._l((_vm.paymentPreference), function(principal, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": principal.name
      }
    }, [_vm._v(_vm._s(principal.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('principalPayment')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestPaymentSelected),
      expression: "interestPaymentSelected"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'form-control-error': _vm.errors.has('interestPayment')
    },
    attrs: {
      "name": "interestPayment",
      "id": "interestPayment",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestPaymentSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select interest payment preference")]), _vm._v(" "), _vm._l((_vm.paymentPreference), function(interest, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": interest.name
      }
    }, [_vm._v(_vm._s(interest.text))])
  })], 2), _vm._v(" "), (_vm.errors.has('interestPayment')) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v("Required")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-approve",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitButtonDisabled(_vm.errors)
    },
    on: {
      "click": function($event) {
        _vm.submitRequest()
      }
    }
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Go back")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  })], 2)])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Tax ID*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Phone number*")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [_c('label', [_vm._v("Additional emails for reporting")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Zip code*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("City*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("State*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Country*")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-title"
  }, [_c('div', [_vm._v("Mailing address")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Zip code*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("City*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("State*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('label', [_vm._v("Country*")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "group-span-filestyle input-group-btn",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('label', {
    staticClass: "btn btn-default document-label",
    attrs: {
      "for": "filestyle-0"
    }
  }, [_c('span', {
    staticClass: "icon-span-filestyle fa fa-folder-open"
  }), _vm._v(" "), _c('span', {
    staticClass: "buttonText"
  }, [_vm._v("Choose file")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("File name")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Uploaded by")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-title space"
  }, [_c('div', [_vm._v("Payment preference")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row top-margin"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', [_c('label', [_vm._v("Principal maturity preference*")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 left-margin"
  }, [_c('div', [_c('label', [_vm._v("Interest payment preference*")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ebb120d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountCreationOrganization.vue
// module id = 2140
// module chunks = 1